<template>
	<div class="bg">
		<div class="search-container">
			<div style="font-size: 16px; font-weight: bold; padding-bottom: 16px;">查询评价</div>

			<!-- 搜索表单区域 -->
			<div class="search-form">
					<!-- 下单时间 -->
				<div class="input-wrapper">
					<label class="input-label">下单时间：</label>
					<el-date-picker v-model="searchParams.orderTimeRange" type="daterange" range-separator="至"
						start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
						style="width: 100%; background-color: #F2F3F5;" :clearable="true">
					</el-date-picker>
				</div>
				<!-- 收货人 -->
				<div class="input-wrapper">
					<label class="input-label">收货人：</label>
					<el-input v-model="searchParams.userName" placeholder="请输入收货人名字" clearable
						style="background-color: #F2F3F5;" @keyup.enter="handleSearch" />
				</div>
				<!-- 手机号 -->
				<div class="input-wrapper">
					<label class="input-label">手机号：</label>
					<el-input v-model="searchParams.phone" placeholder="请输入手机号" clearable
						style="background-color: #F2F3F5;" @keyup.enter="handleSearch" />
				</div>
				<div class="divider"></div>
				<!-- 搜索按钮 -->
				<div class="search flexc" style="cursor: pointer;" @click="handleSearch">
					<img src="/images/goodsList/search.svg" width="14px" height="14px" alt="" />
					<div class="" style="margin-left: 4px; font-size: 14px;">查询</div>
				</div>
			</div>
		</div>
		<div style="margin-top: 20px;">
			<el-table ref="etb2" class="custom-header-table" :height="tblHeight" v-loading="tableLoading"
				:data="remarkList">
				<!-- <el-table-column type="selection"></el-table-column> -->
				<el-table-column type="index" label="序号" width="70" align="center" :index="getTableIndex"></el-table-column>
				<el-table-column label="订单号" align="center" >
					<template slot-scope="scope">
						<div class="price">{{ scope.row.orderSeq || '--' }}</div>
					</template>
				</el-table-column>
				<el-table-column label="收货人" align="center">
					<template slot-scope="scope">
						<div class="price">{{ scope.row.nickName || scope.row.replyUserNickName || '--' }}</div>
					</template>
				</el-table-column>
				<el-table-column label="手机号" align="center">
					<template slot-scope="scope">
						<div class="price">{{ scope.row.memberUserMobile || scope.row.phone || '--' }}</div>
					</template>
				</el-table-column>
				<el-table-column label="商品名称" align="center">
					<template slot-scope="scope">
						<div v-if="scope.row.goodsList && scope.row.goodsList.length > 0">
							<div v-for="(goods, index) in scope.row.goodsList.slice(0, 3)" :key="index"
								class="goods-item">
								{{ goods.name || '商品' }}
							</div>
							<div v-if="scope.row.goodsList.length > 3" class="more-goods">
								...等{{ scope.row.goodsList.length }}件商品
							</div>
						</div>
						<div v-else>--</div>
					</template>
				</el-table-column>
				<el-table-column label="商品数量" align="center">
					<template slot-scope="scope">
						<div class="price">{{ getGoodsTotalNum(scope.row) }}</div>
					</template>
				</el-table-column>
				<el-table-column label="评分" align="center">
					<template slot-scope="scope">
						<div class="price">{{ scope.row.points || 0 }}</div>
					</template>
				</el-table-column>
				<el-table-column label="评价内容" align="center">
					<template slot-scope="scope">
						<div class="evaluate-content">
							<div class="evaluate-item">
								<strong>评价：</strong>{{ scope.row.content || '暂无评价' }}
							</div>
							<div class="reply-item" v-if="scope.row.newestSubReplyInfo">
								<strong>回复：</strong>{{ scope.row.newestSubReplyInfo.content }}
							</div>
							<div class="evaluate-images" v-if="scope.row.evaluateImages && scope.row.evaluateImages.length">
								<el-image v-for="(img, index) in scope.row.evaluateImages" :key="index" :src="img"
									:preview-src-list="scope.row.evaluateImages" class="evaluate-image" fit="cover">
								</el-image>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="评价时间" align="center">
					<template slot-scope="scope">
						<div class="price">{{ formatDateTime(scope.row.updateTime) }}</div>
					</template>
				</el-table-column>
		<el-table-column label="操作" align="center" fixed="right" width="100">
			<template slot-scope="scope">
				<el-tag v-if="hasMerchantReply(scope.row)" type="success" size="mini" class="reply-status">已回复</el-tag>
				<el-tooltip v-else content="回复评价" placement="top" effect="light">
					<el-button circle size="medium" icon="el-icon-chat-dot-round" class="table-btn reply-btn"
						@click="handleReply(scope.row)"></el-button>
				</el-tooltip>
			</template>
		</el-table-column>
			</el-table>
			<div class="flexb" style="margin-top: 20px;">
				<div class="down flexc" style="margin-left: 20px; cursor: pointer;" @click="handleExport">
					<i class="el-icon-folder-add" style="padding-right: 4px;"></i>
					导出
				</div>
				<div class="flexe" style="margin-top: 12px;">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="pagination.currentPage" :page-sizes="[10, 20, 30, 40]"
						:page-size="pagination.pageSize" layout="total, sizes, prev, pager, next, jumper"
						:total="pagination.total" background>
					</el-pagination>
				</div>
			</div>
		</div>

		<!-- 回复对话框 -->
		<el-dialog title="回复评价" :visible.sync="replyDialogVisible" width="500px" :before-close="handleCloseReplyDialog">
			<el-form :model="replyForm" label-width="80px">
				<el-form-item label="评价内容">
					<el-input type="textarea" :rows="3" v-model="currentEvaluate.content" disabled placeholder="评价内容">
					</el-input>
				</el-form-item>
				<el-form-item label="回复内容">
					<el-input type="textarea" :rows="3" v-model="replyForm.replyContent" placeholder="请输入回复内容"
						maxlength="200" show-word-limit>
					</el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="handleCloseReplyDialog">取消</el-button>
				<el-button type="primary" @click="submitReply" :loading="replyLoading">确定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		goodsApi
	} from "@/api";

	export default {
		data() {
			return {
				tableLoading: false,
				searchBtnLoading: false,
				// 搜索参数
				searchParams: {
					userName: '', // 收货人姓名
					phone: '', // 手机号
					orderTimeRange: [] // 下单时间范围
				},
				// 分页参数
				pagination: {
					currentPage: 1,
					pageSize: 10,
					total: 0
				},
				remarkList: [],
				// 回复对话框相关
				replyDialogVisible: false,
				replyLoading: false,
				currentEvaluate: {},
				replyForm: {
					replyContent: ''
				}
			}
		},
		created() {
			this.getRemarkList();
		},
		methods: {
			// 格式化日期时间（年月日时分秒）
			formatDateTime(timestamp) {
				if (!timestamp) return '--';
				const date = new Date(timestamp);
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0');
				const day = String(date.getDate()).padStart(2, '0');
				const hours = String(date.getHours()).padStart(2, '0');
				const minutes = String(date.getMinutes()).padStart(2, '0');
				const seconds = String(date.getSeconds()).padStart(2, '0');
				return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
			},

			// 搜索
			handleSearch() {
				this.pagination.currentPage = 1;
				this.getRemarkList();
			},

			// 重置搜索条件
			handleReset() {
				this.searchParams = {
					userName: '',
					phone: '',
					orderTimeRange: []
				};
				this.pagination.currentPage = 1;
				this.getRemarkList();
			},

			// 每页条数改变
			handleSizeChange(pageSize) {
				this.pagination.pageSize = pageSize;
				this.pagination.currentPage = 1;
				this.getRemarkList();
			},

		// 当前页改变
		handleCurrentChange(currentPage) {
			this.pagination.currentPage = currentPage;
			this.getRemarkList();
		},

		// 序号
		getTableIndex(index) {
			return (this.pagination.currentPage - 1) * this.pagination.pageSize + index + 1;
		},

		// 商品数量合计
		getGoodsTotalNum(row) {
			if (!row.goodsList || row.goodsList.length === 0) {
				return '--';
			}
			const total = row.goodsList.reduce((sum, item) => {
				const num = Number(item.num) || 0;
				return sum + num;
			}, 0);
			return total || 0;
		},

		// 获取评价列表
		async getRemarkList() {
				this.tableLoading = true;
				try {
					// 构建请求参数
					const params = {
						pageNo: this.pagination.currentPage,
						pageSize: this.pagination.pageSize
					};

					// 添加搜索条件
					if (this.searchParams.userName) {
						params.userNameLike = this.searchParams.userName.trim();
					}
					if (this.searchParams.phone) {
						params.phone = this.searchParams.phone.trim();
					}
					if (this.searchParams.orderTimeRange && this.searchParams.orderTimeRange.length === 2) {
						params.startTime = this.searchParams.orderTimeRange[0] + ' 00:00:00';
						params.endTime = this.searchParams.orderTimeRange[1] + ' 23:59:59';
					}

					const response = await goodsApi.remark(params);

					if ((response.code === 0 || response.code === 200) && response.data) {
						this.remarkList = response.data.list || [];
						this.pagination.total = response.data.total || response.data.count || 0;

						// 处理数据格式，确保有商品列表数组
						this.remarkList = this.remarkList.map(item => {
							// 如果goodsList不存在，尝试从其他字段获取或设置为空数组
							if (!item.goodsList) {
								item.goodsList = item.goods ? [item.goods] : [];
							}
						// 确保goodsList是数组
						if (!Array.isArray(item.goodsList)) {
							item.goodsList = [item.goodsList];
						}
						item.evaluateImages = [item.imageUrl, item.imageUrl1, item.imageUrl2].filter(Boolean);
						return item;
					});
						this.currentEvaluate.evaluate = this.remarkList.newestSubReplyInfo
						// 如果没有数据且不是第一页，则自动跳转到上一页
						if (this.remarkList.length === 0 && this.pagination.currentPage > 1) {
							this.pagination.currentPage -= 1;
							this.getRemarkList();
							return;
						}
					} else {
						this.$message.error(response.msg || '获取评价列表失败');
					}
				} catch (err) {
					console.error('获取评价列表错误:', err);
					this.$message.error('网络异常，无法获取评价列表');
				} finally {
					this.tableLoading = false;
				}
			},

		// 是否已回复（商家只允许回复一次）
		hasMerchantReply(row) {
			return Boolean(row && row.newestSubReplyInfo);
		},

		// 回复评价
		handleReply(row) {
				if (this.hasMerchantReply(row)) {
					this.$message.warning('该评价已回复，不能重复回复');
					return;
				}
				this.currentEvaluate = {
					...row
				};
				this.replyForm.replyContent = '';
				this.replyDialogVisible = true;
			},

		// 提交回复
		async submitReply() {
			const content = this.replyForm.replyContent.trim();
			if (!content) {
				this.$message.warning('请输入回复内容');
				return;
			}
			if (this.hasMerchantReply(this.currentEvaluate)) {
				this.$message.warning('该评价已回复，不能重复回复');
				return;
			}
			if (!this.currentEvaluate.orderId) {
				this.$message.warning('订单ID缺失，无法回复');
				return;
			}

			this.replyLoading = true;
			try {
				const payload = {
					orderId: this.currentEvaluate.orderId,
					content,
					creatorType: 2
				};

				// 回复订单的评论id，为空则是直接对订单的回复
				payload.replyMainId = this.currentEvaluate.replyMainId || this.currentEvaluate.id;
				if (this.currentEvaluate.storeId) {
					payload.storeId = this.currentEvaluate.storeId;
				}
				if (this.currentEvaluate.promoGoodsId) {
					payload.promoGoodsId = this.currentEvaluate.promoGoodsId;
				}

				const response = await goodsApi.createOrderReply(payload);

				if (response.code === 0 || response.code === 200) {
					this.$message.success('回复成功');
					this.replyDialogVisible = false;
						this.getRemarkList(); // 刷新列表
					} else {
						this.$message.error(response.msg || '回复失败');
					}
				} catch (err) {
					console.error('回复评价错误:', err);
					this.$message.error('回复失败，请重试');
				} finally {
					this.replyLoading = false;
				}
			},

			// 关闭回复对话框
			handleCloseReplyDialog() {
				this.replyDialogVisible = false;
				this.replyForm.replyContent = '';
				this.currentEvaluate = {};
			},

			// 导出功能
			handleExport() {
				// 构建导出参数
				const exportParams = {
					...this.searchParams,
					pageNo: 1,
					pageSize: this.pagination.total // 导出所有数据
				};

				// 移除空值参数
				Object.keys(exportParams).forEach(key => {
					if (exportParams[key] === '' || exportParams[key] === null || exportParams[key] ===
						undefined) {
						delete exportParams[key];
					}
				});

				console.log('导出参数:', exportParams);
				this.$message.info('导出功能开发中...');
			}
		}
	}
</script>

<style lang="scss" scoped>
	.bg {
		// 商品列表样式
		.goods-item {
			font-size: 12px;
			margin: 2px 0;
			color: #606266;
		}

		.more-goods {
			font-size: 11px;
			color: #909399;
			font-style: italic;
		}

		// 评价内容样式
		.evaluate-content {
			text-align: left;
			font-size: 12px;
			line-height: 1.4;
		}

		.evaluate-images {
			display: flex;
			flex-wrap: wrap;
			gap: 6px;
			margin-top: 6px;
			justify-content: center;
		}

		.evaluate-image {
			width: 48px;
			height: 48px;
			border-radius: 4px;
		}

		.evaluate-item,
		.reply-item {
			margin-bottom: 5px;
		}

		.evaluate-item strong,
		.reply-item strong {
			color: #303133;
		}

		// 图片计数样式
		.image-count {
			position: absolute;
			bottom: 2px;
			right: 2px;
			background: rgba(0, 0, 0, 0.6);
			color: white;
			padding: 1px 4px;
			font-size: 10px;
			border-radius: 2px;
		}

		// 回复按钮样式
		.reply-btn {
			background-color: #FFFAE8;
			color: #F79800;
			border: none;
		}

		.reply-btn:hover {
			background-color: #66b1ff;
		}

		.reply-status {
			font-weight: 400;
		}
	}

	// 评分组件样式
	::v-deep .el-rate {
		display: inline-block;
	}

	::v-deep .el-rate__icon {
		font-size: 14px;
	}
</style>
